























































































































































































































































import WidgetMixins from '@/mixins/WidgetMixins';
import {
  IDeliveryLog,
  ILogsFilterAccount,
  ILogsFilters,
} from '@/store/modules/messages-management';
import { IPaginate } from '@/types/types';
import { loadWidget } from '@/utils/helpers';
import moment from 'moment';
import qs from 'qs';
import Component, { mixins } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const messagesManagementModule = namespace('messagesManagement');

@Component({
  name: 'Logs',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
  },
  filters: {
    timestamp(value: string, format?: string) {
      return value ? moment(value).format(format ?? 'Do MMMM, YYYY') : '—';
    },
    formatNumber(value: number) {
      return Number(value ?? 0).toLocaleString();
    },
  },
})
export default class Logs extends mixins(WidgetMixins) {
  @messagesManagementModule.Getter('getLogs') logs!: IDeliveryLog[];
  @messagesManagementModule.Getter('getLogsPagination') paginate!: IPaginate;
  @messagesManagementModule.Getter('getLogsTotalSegments') totalSegments!: number;
  @messagesManagementModule.Getter('getLogsFilters') logsFilters!: ILogsFilters;

  options: any = { sortBy: ['createdAt'], sortDesc: [true] };
  query = '';
  statuses: string[] = ['ALL', 'DELIVERED', 'UNDELIVERED', 'ACCEPTED', 'PENDING', 'REJECTED', 'EXPIRED', 'FAILED'];

  userId: number | null = null;
  senderIds: string[] = [];
  status = 'ALL';
  searchTerm = '';
  startDate: string | null = null;
  endDate: string | null = null;
  startDateMenu = false;
  endDateMenu = false;

  expanded: IDeliveryLog[] = [];

  headers: Array<{ text: string; value: string; sortable?: boolean }> = [
    { text: 'Date', value: 'createdAt' },
    { text: 'Customer', value: 'customer', sortable: false },
    { text: 'Sender', value: 'senderAddress', sortable: false },
    { text: 'Recipient', value: 'receiverAddress', sortable: false },
    { text: 'Message', value: 'message', sortable: false },
    { text: 'Segments', value: 'segments', sortable: false },
    { text: 'Status', value: 'deliveryStatus', sortable: false },
  ];

  get customerItems(): Array<{ header: string } | { id: number; text: string }> {
    const toItem = (account: ILogsFilterAccount) => ({
      id: account.id,
      text: `${account.name} — ${account.email}`,
    });
    return [
      { header: 'Main Accounts' },
      ...this.logsFilters.mainAccounts.map(toItem),
      { header: 'Sub Accounts' },
      ...this.logsFilters.subAccounts.map(toItem),
    ];
  }

  customerName(consumerId: string | number): string {
    const accounts = [...this.logsFilters.mainAccounts, ...this.logsFilters.subAccounts];
    const account = accounts.find(item => `${item.id}` === `${consumerId}`);
    if (!account) return consumerId ? `#${consumerId}` : '—';
    return account.isSubAccount ? `${account.name} (sub)` : account.name;
  }

  formatRecipient(receiver: string | string[]): string {
    return Array.isArray(receiver) ? receiver.join(', ') : receiver || '—';
  }

  truncateText(value: string | null, length: number): string {
    if (!value) return '—';
    return value.length > length ? `${value.slice(0, length)}…` : value;
  }

  statusClass(status: string): string {
    const normalized = (status || '').toLowerCase();
    if (['delivered', 'delivrd'].includes(normalized)) return 'ka-status--success';
    if (['undelivered', 'undeliv', 'rejected', 'expired', 'failed'].includes(normalized)) return 'ka-status--error';
    if (['accepted', 'pending'].includes(normalized)) return 'ka-status--info';
    return 'ka-status--warning';
  }

  buildQuery(overrides: any = {}): string {
    const params: any = {
      page: this.paginate.page,
      size: this.paginate.itemsPerPage,
      ...(this.status !== 'ALL' && { status: this.status }),
      ...(this.userId !== null && { userId: this.userId }),
      ...(this.senderIds.length > 0 && { filters: this.senderIds.join(',') }),
      ...(this.searchTerm && { searchTerm: this.searchTerm }),
      ...(this.startDate && { startDate: this.startDate }),
      ...(this.endDate && { endDate: this.endDate }),
      ...overrides,
    };
    return qs.stringify(params, { skipNulls: true, addQueryPrefix: true });
  }

  fetchLogs(): void {
    this.query = this.buildQuery({ page: 1 });
    this.$store.dispatch('messagesManagement/listLogs', this.query);
  }

  exportLogs(): void {
    const exportQuery = this.buildQuery();
    this.$store.dispatch('messagesManagement/exportLogs', {
      query: exportQuery,
      fileName: `sms-delivery-logs-${this.startDate ?? 'all'}-${this.endDate ?? 'all'}.csv`,
    });
  }

  toggleExpand(log: IDeliveryLog): void {
    this.expanded = this.expanded.some(item => item._id === log._id) ? [] : [log];
  }

  detailFields(log: IDeliveryLog): Array<{ label: string; value: string | number }> {
    const raw = log as IDeliveryLog & { [key: string]: any };
    return [
      { label: 'Customer', value: this.customerName(log.consumerId) },
      { label: 'Recipient', value: this.formatRecipient(log.receiverAddress) },
      { label: 'Status', value: log.deliveryStatus || '—' },
      { label: 'Segments', value: log.segments || 1 },
      { label: 'Transaction ID', value: raw.transactionId || '—' },
      { label: 'Message ID', value: raw.messageId || '—' },
      { label: 'Correlator', value: raw.clientCorrelatorId || raw.sequenceNo || '—' },
      { label: 'Gateway ID', value: raw.gatewayId || '—' },
      { label: 'Business ID', value: raw.businessId || '—' },
      { label: 'Submitted', value: raw.submittedDate ? moment(raw.submittedDate).format('DD/MM/YYYY HH:mm:ss') : '—' },
      { label: 'Completed', value: raw.completedDate ? moment(raw.completedDate).format('DD/MM/YYYY HH:mm:ss') : '—' },
      { label: 'Created', value: log.createdAt ? moment(log.createdAt).format('DD/MM/YYYY HH:mm:ss') : '—' },
    ];
  }

  onSearchCleared(): void {
    this.searchTerm = '';
    this.fetchLogs();
  }

  @Watch('userId')
  onUserChange(): void {
    this.fetchLogs();
  }

  @Watch('senderIds')
  onSenderIdsChange(): void {
    this.fetchLogs();
  }

  @Watch('status')
  onStatusChange(): void {
    this.fetchLogs();
  }

  @Watch('startDate')
  onStartDateChange(): void {
    this.fetchLogs();
  }

  @Watch('endDate')
  onEndDateChange(): void {
    this.fetchLogs();
  }

  @Watch('options', { deep: true })
  onOptionsChange(paginate: IPaginate): void {
    const query = this.buildQuery({ page: paginate.page, size: paginate.itemsPerPage });
    if (query === this.query) return;
    this.query = query;
    this.$store.dispatch('messagesManagement/listLogs', this.query);
  }

  created(): void {
    this.$store.dispatch('auth/me');
    this.$store.dispatch('messagesManagement/logsFilters');
    if (this.$route.query?.userId) {
      this.userId = Number(this.$route.query.userId);
    }
    this.startDate = moment()
      .subtract(7, 'days')
      .format('YYYY-MM-DD');
    this.endDate = moment().format('YYYY-MM-DD');
    this.fetchLogs();
  }
}
